var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _path9, _path0, _path1, _path10, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsPostAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.166 8.1701L8 29H33.5L29.3817 8.40868C29.1309 7.15452 28.5688 5.95225 27.4355 5.35948C26.175 4.7002 24.0577 4 20.75 4C17.2475 4 15.0797 4.78514 13.8506 5.47542C12.8748 6.02344 12.3855 7.07271 12.166 8.1701Z",
    fill: "#F994C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 29L12.1183 8.40868C12.3691 7.15452 12.9312 5.95225 14.0645 5.35948C15.325 4.7002 17.4423 4 20.75 4C21.3656 4 21.8138 4.02425 22.1217 4.06798C18 4.5 16.5 5.5 16 7.5C15.5 9.5 11.5 29 11.5 29H8Z",
    fill: "#ED6AA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H6",
    stroke: "#EA76AE",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5L6.43185 14.0176",
    stroke: "#EA76AE",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.0176L6.43185 21.4999",
    stroke: "#EA76AE",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9316 18H34.9316",
    stroke: "#EA76AE",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4316 13.5L34.4998 14.0176",
    stroke: "#EA76AE",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4316 22.0176L34.4998 21.4999",
    stroke: "#EA76AE",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1858,
    y: 20.3213,
    width: 1.72859,
    height: 8.64293,
    fill: "#C6377C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0502,
    y: 20.3213,
    width: 0.864293,
    height: 8.64293,
    fill: "#DD428D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3214,
    y: 16.8643,
    width: 3.45717,
    height: 5.18576,
    rx: 0.864293,
    fill: "#DD428D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1857,
    y: 16.8643,
    width: 2.59288,
    height: 5.18576,
    rx: 0.864293,
    fill: "#ED6AA9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.3367C14 16.7095 14.647 16.2912 15.219 16.5485L17.8118 17.7153C18.122 17.8549 18.3215 18.1634 18.3215 18.5035V19.2463C18.3215 19.6279 18.0711 19.9644 17.7055 20.0741L15.1126 20.852C14.5581 21.0183 14 20.6031 14 20.0241V17.3367Z",
    fill: "#E95BA0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.3367C14 16.7095 14.647 16.2912 15.219 16.5485L18.0466 17.821C18.2139 17.8962 18.3215 18.0626 18.3215 18.2461C18.3215 18.4519 18.1864 18.6334 17.9893 18.6925L15.1126 19.5555C14.5581 19.7219 14 19.3066 14 18.7277V17.3367Z",
    fill: "#F879B6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1003 17.3367C26.1003 16.7095 25.4533 16.2912 24.8814 16.5485L22.2885 17.7153C21.9783 17.8549 21.7789 18.1634 21.7789 18.5035V19.2463C21.7789 19.6279 22.0292 19.9644 22.3948 20.0741L24.9877 20.852C25.5422 21.0183 26.1003 20.6031 26.1003 20.0241V17.3367Z",
    fill: "#E95BA0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1003 17.3367C26.1003 16.7095 25.4533 16.2912 24.8814 16.5485L22.0537 17.821C21.8865 17.8962 21.7789 18.0626 21.7789 18.2461C21.7789 18.4519 21.9139 18.6334 22.1111 18.6925L24.9877 19.5555C25.5422 19.7219 26.1003 19.3066 26.1003 18.7277V17.3367Z",
    fill: "#F879B6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29,
    width: 29,
    height: 2.5,
    rx: 1,
    fill: "#99C8FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 26,
    height: 2.5,
    rx: 1,
    fill: "#BDDBFC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 31.5,
    width: 33,
    height: 4,
    rx: 1,
    fill: "#BDDBFC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 31.5,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#DEECFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsPostAlert);
export default __webpack_public_path__ + "static/media/news-post-alert.0aa6274921d83460b0c4b4ea1ddad76d.svg";
export { ForwardRef as ReactComponent };